import React from "react";
import { Col, Row, Form, Modal, Select, Radio, Spin, InputNumber, Tag, Space } from "antd";
import { URL_SALE, URL_SKIM } from "../../constants/urls";
import { GET, POST } from "../../frameworks/HttpClient";
import _ from "lodash";
import ErrorMessages from "../../common/ErrorMessages";
import { TANK_STATUS } from "../../constants/string";
import ColorButton from "../../common/ColorButton";
import { PRIMARY_COLOR } from "../../constants/color";

export default function LoadSkimProduceLotModal(props) {
  const { open, onClose, target, onUpdate, saleOrder } = props;
  const [errorMessages, setErrorMessages] = React.useState(null)
  const [debouncedLot, setDebouncedLot] = React.useState(null);
  const [fetching, setFetching] = React.useState(null);
  const [currentStockWeight, setCurrentStockWeight] = React.useState(null);
  const [lotOptions, setLotOptions] = React.useState(null);

  const [form] = Form.useForm();
  const isSelfOrder = Form.useWatch("self_order", form);

  const debounceLot = React.useCallback(_.debounce((_searchVal) => { setDebouncedLot(_searchVal) }, 800), []);

  const fetchLotSkim = async () => {
    setFetching(true);
    try {
      const response = await GET(`${URL_SKIM.SKIM_PRODUCE_TRANSACTION }`, { sale_order : isSelfOrder ? saleOrder.id : '', lot_no : debouncedLot, is_closed : false })
      setLotOptions(response.data.results.map((item) => {
        return {
          ...item,
          label: `${item.lot_no} [${item.product_name}] - ${item.produce_lot_no ? item.produce_lot_no : "ไม่ระบุ"} : ${item.current_stock_amount} ก้อน`,
          value: item.id
        }
      }))
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setFetching(false);
    }
  }

  const handleOK = async () => {
    setErrorMessages(null)
    try {
      const data = await form.validateFields();
      data['delivery_order'] = target.id
      await POST(`${URL_SALE.LOAD_SKIM_STOCK}load-produce-lot/`, data);
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  };

  React.useEffect(() => {
    if(open)
      fetchLotSkim();
  },[debouncedLot])

  React.useEffect(() => {
    if(isSelfOrder != null){
      fetchLotSkim();
    }
  },[isSelfOrder])

  React.useEffect(() => {
    setErrorMessages(null)
    if(open){
      fetchLotSkim();
      form.setFieldValue('self_order', true)
    } else{
      setCurrentStockWeight(0)
    }
  },[open])

  return(
    <Modal
      open={open}
      onCancel={() => {
        form.resetFields()
        onClose()
      }}
      cancelText={"ยกเลิก"}
      okText={"โหลด"}
      title={"โหลดสกิม (ล็อตผลิต)"}
      width={500}
      onOk={handleOK}
      centered
      destroyOnClose
      footer={[
        <>
          <div style={{ textAlign: 'left' }}>
            <Space>
              <div style={{ margin: 10, width: 300}}>
                {`น้ำหนักประมาณ(kg) :  `} <Tag color="blue">{currentStockWeight ? Number(currentStockWeight).toFixed(2) : 0}</Tag>
              </div>
              <div style={{ textAlign: 'right', width: 150}}>
                <ColorButton onClick={onClose}>ปิด</ColorButton>
                <ColorButton type='primary' onClick={handleOK} style={{ marginLeft : 10}} override={PRIMARY_COLOR}>โหลด</ColorButton>
              </div>
            </Space>
          </div>  
        </>
      ]}
    >
    <ErrorMessages message={errorMessages}/>
    <Form
      form={form}
      style={{ margin: "auto", marginBottom: 50}}
      layout="horizontal"
    >
      <Form.Item
        label="ล็อตการผลิต"
        name="produce_transaction"
        layout="vertical"
        rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
      >
        <Select 
          initialvalues={"-"}
          autoComplete="off"
          placeholder={"ล็อตการผลิต"}
          showSearch
          filterOption={false}
          notFoundContent={fetching ? <Spin size="small" /> : "-"}
          onSearch={debounceLot}
          options={_.filter(lotOptions, (e) => e.current_stock_amount > 0 )}
          onSelect={(e, option) => setCurrentStockWeight(option.current_stock_weight)}
          onClear={() => setCurrentStockWeight(0)}
          allowClear={"-"}/>
      </Form.Item>
    </Form>
  </Modal>)
}